// extracted by mini-css-extract-plugin
module.exports = {"role":"style_role__1EJYZ","active":"style_active__1sXZj"};